import { captureException } from "@sentry/react"
import dayjs from "dayjs"

import { ScheduledChannelMessage } from "../../types/scheduledMessages"
import { createJoonAPIClient } from "../../util/joon-api"
import { getRoutineFromTimeString } from "../../util/time"

export const createScheduledMessage = async ({
  groupId,
  message,
  datetime,
  resourceId,
}: {
  groupId: number
  message: string
  datetime: string
  resourceId: number
}) => {
  const API = createJoonAPIClient()
  try {
    const response = await API.post("api/scheduled-channel-messages/", {
      group_id: groupId,
      message,
      datetime,
      resource_id: resourceId,
    })
    return response.data
  } catch (error) {
    captureException(error)
    throw error
  }
}

export const updateScheduledMessage = async ({
  messageId,
  message,
  datetime,
  resourceId,
}: {
  messageId: number
  message: string
  datetime: string
  resourceId: number | null | undefined // null to delete resource
}) => {
  const API = createJoonAPIClient()
  try {
    const response = await API.patch(
      `api/scheduled-channel-messages/${messageId}/`,
      { message, datetime, resource_id: resourceId }
    )
    return response.data
  } catch (error) {
    captureException(error)
    throw error
  }
}

export const getScheduledMessages = async ({
  groupId,
  minDatetime,
  maxDatetime,
}: {
  groupId: number
  minDatetime: string
  maxDatetime?: string
}) => {
  const API = createJoonAPIClient()
  try {
    const response = await API.get<{ results: ScheduledChannelMessage[] }>(
      "api/scheduled-channel-messages/",
      {
        params: {
          group_id: groupId,
          min_datetime: minDatetime,
          max_datetime: maxDatetime,
        },
      }
    )

    return response.data.results
      .map((message) => ({
        ...message,
        routine: getRoutineFromTimeString(
          dayjs(message.datetime).format("HH:mm")
        ),
      }))
      .sort((a, b) => dayjs(a.datetime).diff(dayjs(b.datetime)))
  } catch (error) {
    captureException(error)
    throw error
  }
}

export const deleteScheduledMessage = async ({
  messageId,
}: {
  messageId: number
}) => {
  const API = createJoonAPIClient()
  try {
    const response = await API.delete(
      `api/scheduled-channel-messages/${messageId}/`
    )
    return response.data
  } catch (error) {
    captureException(error)
    throw error
  }
}
